import { render, staticRenderFns } from "./CreatePassword.vue?vue&type=template&id=0925e423&scoped=true&lang=pug"
import script from "./CreatePassword.vue?vue&type=script&lang=js"
export * from "./CreatePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0925e423",
  null
  
)

export default component.exports